export const formatPrice = (price: string | undefined | number | null) => {
    return `${Math.round(Number(price) * 100) / 100} RSD`;
};

export const discountPrice = (price: number, discount: string | number | undefined) => {
    if (discount !== '0' && discount !== '') {
        return price * (1 - Number(discount) / 100);
    } else {
        return '';
    }
};

export const discountCalc = (price: string | number, discountedPrice: string | number) => {
    if (discountedPrice === '0') {
        return '0';
    } else {
        const discount = ((Number(price) - Number(discountedPrice)) / Number(price)) * 100;
        return (Math.round(discount * 100) / 100).toString();
    }
};
